import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Field } from 'redux-form';
import PlusIcon from 'mdi-react/PlusIcon';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';
import ArrowDownIcon from 'mdi-react/ArrowDownIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import { partial } from '../../../util/translation/translation';
import renderDropZoneField from '../../../shared/components/form/DropZoneMS';
import renderTexField from '../../../shared/components/custom/Field';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';

const s = partial('shared');
const p = partial('NewsForm');

export const MAX_CAROUSEL_SLIDES = 10;

// The images of a carousel component (a redux-form FieldArray): each with
// the same crop as an image component, a link and a credit, in order
const CarouselSlidesField = ({ fields }) => (
  <div className="news-carousel-slides">
    {fields.map((slide, index) => (
      <div key={slide} className="news-carousel-slides__slide">
        <div className="news-carousel-slides__header">
          <span className="bold">
            {p('IMAGE_CAROUSEL_slide', { number: index + 1 })}
          </span>
          <div className="icon-actions">
            <SquareIconButton
              icon={<ArrowUpIcon size={16} />}
              title={p('IMAGE_CAROUSEL_moveUp')}
              disabled={index === 0}
              onClick={() => fields.move(index, index - 1)}
            />
            <SquareIconButton
              icon={<ArrowDownIcon size={16} />}
              title={p('IMAGE_CAROUSEL_moveDown')}
              disabled={index === fields.length - 1}
              onClick={() => fields.move(index, index + 1)}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon size={16} />}
              title={p('IMAGE_CAROUSEL_remove')}
              tone="danger"
              onClick={() => fields.remove(index)}
            />
          </div>
        </div>
        <Field
          saveBase64Cropped
          name={`${slide}.image`}
          maxSize={3}
          component={renderDropZoneField}
          crop="NEWS_OPTIONS_CROP"
          displayCrop
        />
        <Field
          name={`${slide}.link`}
          component={renderTexField}
          placeholder={s('link')}
        />
        <Field
          name={`${slide}.author`}
          component={renderTexField}
          placeholder={p('IMAGE_PHOTOGRAPHER_title')}
        />
      </div>
    ))}
    {fields.length < MAX_CAROUSEL_SLIDES && (
      <Button
        type="button"
        outline
        size="sm"
        onClick={() => fields.push({ author: '', link: '' })}
      >
        <PlusIcon size={16} /> {p('IMAGE_CAROUSEL_add')}
      </Button>
    )}
  </div>
);

CarouselSlidesField.propTypes = {
  fields: PropTypes.shape({
    map: PropTypes.func.isRequired,
    move: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    length: PropTypes.number.isRequired,
  }).isRequired,
};

export default CarouselSlidesField;
